export const focusElementByName = (name) => {
    const element = document.getElementsByName(name)?.[0];
    element?.focus();
};

export const downloadFile = (blob, fileName, format) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}_${new Date().toISOString().split('T')[0]}.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
};

/**
 * Open a URL in a new tab securely with fallback
 * @param {string} url - The URL to open
 */
export const openInNewTab = (url) => {
    if (!url) return;

    const newWindow = window.open(url, '_blank');
    !newWindow ? (window.location.href = url) : (newWindow.opener = null);
};
